import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { FlagsProvider } from 'flagged'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { LicenseInfo } from '@mui/x-license'
import theme from './themes/theme'
import App from './App'
import { getFeatureFlags } from './utils/feature-flag-utils'
import { persistor, store } from './app/store'

const featureFlags = getFeatureFlags()

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE_KEY)

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <FlagsProvider features={featureFlags}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <ThemeProvider theme={theme}>
              <App />
            </ThemeProvider>
          </LocalizationProvider>
        </PersistGate>
      </Provider>
    </FlagsProvider>
  </React.StrictMode>,
)
